module.exports = __webpack_public_path__ + "img/visma-admin.654eb571.png";